import { useCallback, useEffect } from 'react';
import { setEditAlert } from 'redux/reducers/meteorologyAgroGroupLocationFeedbackReducer';
import { store } from 'redux/store';
import { ResponseError } from 'services/api/base';
import { useUpdateAgroLocationMutation } from 'services/api/Meteorology/Agro';

export default function useUpdateLocation() {
  const [trigger, { data, isLoading, error }] = useUpdateAgroLocationMutation();
  const updateLocation = useCallback((id: number, name: string) => {
    trigger({ id, name });
  }, [trigger]);

  useEffect(() => {
    if (error) {
      const responseError = error as ResponseError;
      store.dispatch(setEditAlert({
        title: responseError.data || 'Erro',
        message: responseError.description || 'Ocorreu um erro ao editar o local.',
        variant: 'danger',
      }));
    }
  }, [error]);

  useEffect(() => {
    if (data) {
      store.dispatch(setEditAlert({
        title: data.title || 'Sucesso',
        message: data.message || 'Local editado com sucesso.',
        variant: 'success',
      }));
    }
  }, [data]);

  return {
    updateLocation,
    isUpdatingLocation: isLoading,
  };
}
